<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">E-mail</th>
        <th scope="col" class="border-0">Telefone</th>
        <th scope="col" class="text-center border-0">Web</th>
        <th scope="col" class="text-center border-0" v-if="showColors">Colors</th>
        <th scope="col" class="border-0" v-if="!isRepresentative">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in resellers" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: 'admin-reseller-edit', params: { resellerId: row.id }}">{{ row.name }}</d-link>
        </td>
        <td class="td-3">{{ row.email }}</td>
        <td class="td-2">{{ row.phone }}</td>
        <td class="text-center td-1">
          <i class="fas fa-info-circle" :id="'tooltip-'+index"></i>
          <d-tooltip :target="'#tooltip-'+index" container=".tooltip-container">
            <p class="m-0 tooltip-date"><i class="fas fa-globe"></i> {{ row.site }}</p>
            <p class="m-0 tooltip-date"><i class="fab fa-facebook"></i> {{ row.social_medias.facebook }}</p>
            <p class="m-0 tooltip-date"><i class="fab fa-instagram"></i> {{ row.social_medias.instagram }}</p>
          </d-tooltip>
        </td>
        <td class="text-center td-1" v-if="showColors">
          <i v-if="row.premium" class="fas fa-check text-success"></i>
          <i v-else class="fas fa-times text-danger"></i>
        </td>
        <td class="td-2" v-if="!isRepresentative">
          <reseller-buttons :reseller="row" @blockAccess="blockAccess"></reseller-buttons>
        </td>
      </tr>
      <tr v-if="resellers.length === 0">
        <td colspan="7" class="no-content">Ainda não tem nenhum parceiro cadastrado.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      :title="title"
      :message="message"/>
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import config from '_config';
import Events from '_utils/events';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import ResellerButtons from './ResellerButtons.vue';
import ResellerActions from './ResellerActions';
import { _DELETE_RESELLER_ } from './ResellerModel';

export default {
  name: 'reseller-table',
  mixins: [ResellerActions],
  components: {
    ResellerButtons,
    ConfirmationModal,
  },
  props: {
    resellers: {
      type: Array,
    },
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
    isCommercial() {
      const { user } = this.$store.state.user;
      if (user && user.settings.user_type_id === config.COMMERCIAL_TYPE_ID) {
        return true;
      }
      return false;
    },
    isRepresentative() {
      const { user } = this.$store.state.user;
      if (user && user.settings.type.slug === 'representative') {
        return true;
      }
      return false;
    },
    showColors() {
      if (this.isAdmin || this.isCommercial) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      selectReseller: null,
      title: 'Confirme desabilitar de parceiro',
      message: 'Tem certeza que deseja desabilitar esse parceiro?',
    };
  },
  methods: {
    ...mapActions([
      'checkAdmin',
    ]),
  },
  mounted() {
    this.checkAdmin();
    Events.$on(_DELETE_RESELLER_, reseller => {
      this.selectReseller = reseller.id;
      if (reseller.deleted_at) {
        this.title = 'Confirme habilitar de parceiro';
        this.message = 'Tem certeza que deseja habilitar esse parceiro?';
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}

.td {
  &-1 {
    min-width: 100px;
  }
  &-2 {
    min-width: 140px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}

.tooltip {
  .tooltip-inner {
    max-width: 400px;
    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 400px;
      font-size: 14px;
    }
  }
}
</style>
